// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';
import { CompanySizeSchema } from '../inputTypeSchemas/CompanySizeSchema'

/////////////////////////////////////////
// EXTERNAL NETWORK PROFILE SCHEMA
/////////////////////////////////////////

export const ExternalNetworkProfileSchema = z.object({
  companySize: CompanySizeSchema.nullable(),
  id: z.string(),
  tenantId: z.string().nullable(),
  surfaceId: z.string(),
  description: z.string().nullable(),
  primaryIndustry: z.string().nullable(),
  locations: z.string().array(),
  brandsServicesProducts: z.string().array(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
})

export type ExternalNetworkProfile = z.infer<typeof ExternalNetworkProfileSchema>

export default ExternalNetworkProfileSchema;
